import { OpenModal } from 'contexts/ModalContext/ModalContext.type';

export const handleActivateTrialSubscription = ({
    openModal,
}: {
    openModal: OpenModal;
}) => {
    openModal.activateTrialSubscription();
};
